module.exports = __webpack_public_path__ + "static/img/img_awards_3en.eb878c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/img_awards_3en.png
// module id = xIB/
// module chunks = 15